import { render, staticRenderFns } from "./ProjectViewRequestee.vue?vue&type=template&id=013455d1&scoped=true"
import script from "./ProjectViewRequestee.vue?vue&type=script&lang=js"
export * from "./ProjectViewRequestee.vue?vue&type=script&lang=js"
import style0 from "./ProjectViewRequestee.vue?vue&type=style&index=0&id=013455d1&prod&lang=css"
import style1 from "./ProjectViewRequestee.vue?vue&type=style&index=1&id=013455d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013455d1",
  null
  
)

export default component.exports